import Highcharts from "./highchartsSetup";
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsReact from "highcharts-react-official";
import {useAuth} from "../../hooks/useAuth";
import {forwardRef} from "react";
HighchartsMore(Highcharts);

interface CustomBoxplotChartProps extends HighchartsReact.Props {}

const CustomBoxplotChart = forwardRef<HighchartsReact.RefObject, CustomBoxplotChartProps>(({ series, xAxis, ...rest }, ref) => {
    const {user} = useAuth();

    const options: Highcharts.Options = {
        exporting: {
            enabled: false, // hides the export menu button
        },
        accessibility: {
            enabled: false,
        },
        chart: {
            type: "boxplot",
            inverted: true,
            backgroundColor: "#FFFFFF",
            height: series[0].data.length * 65 + 65,
        },
        title: {
            text: "",
        },
        plotOptions: {
            boxplot: {
                lineWidth: 2,
                medianWidth: 4,
            },
            series: {
                // @ts-ignore
                colorByPoint: true,
                pointWidth: 30,
                groupPadding: 0,
                pointPadding: 0,
            }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: 'Centile'
            }
        },
        legend: {
            enabled: false
        },
        colors: user.theme === "light" ? ["#0064FF", "#9D0000", "#008D2C", "#B948DB", "#00289B", "#DE6525"] : ["#0064FF", "#ED0000", "#008D2C", "#B948DB", "#98C0FF", "#DE6525"] ,
    }

    return (
        <>

            <HighchartsReact highcharts={Highcharts} options={{ ...options, series, xAxis }} ref={ref} {...rest}/>
        </>

    )
});

export default CustomBoxplotChart;